// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2925":"3090b5dfdb172463","3909":"6ab71ed7c64c2f75","4302":"657e46a681bf8bdd","5778":"22951a8ab4d99274","9081":"f7f644b6c6d6c9ac","9105":"ea72bc138b9e4410"}[chunkId] + ".css";
};